export default __webpack_public_path__ + "static/media/effing.997ace98.png";